module.exports = __webpack_public_path__ + "static/gallery-15-3222d9ae028db96ef690bbd4dbb3e848.jpg";